import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1F1F1F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/onehill-icon.png"
                alt="OneHill"
                className="h-12 w-auto select-none"
                draggable="false"
              />
              <div>
                <div className="font-display font-black text-2xl tracking-tight leading-none">
                  <span className="text-[#99CC00]">One</span>Hill
                </div>
                <div className="text-[10px] font-bold tracking-[0.28em] text-white/55 mt-1.5">COMMERCE PVT. LTD.</div>
              </div>
            </div>
            <p className="text-base text-white/65 max-w-md leading-relaxed">
              Quick Commerce Expansion & Operations Partner. Powering the ground execution behind India’s fastest QC growth — from dark store management to fulfilment networks.
            </p>
            <div className="mt-7 inline-flex items-center gap-2 rounded-full border border-[#99CC00]/60 px-4 py-2 text-[11px] font-bold tracking-[0.2em] uppercase text-[#99CC00]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#99CC00] animate-pulse" />
              Powering Quick Commerce Expansion
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-black text-base mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="text-white/65 hover:text-[#99CC00] transition-colors">Home</Link></li>
              <li><Link data-testid="footer-link-services" to="/services" className="text-white/65 hover:text-[#99CC00] transition-colors">Services</Link></li>
              <li><Link data-testid="footer-link-framework" to="/framework" className="text-white/65 hover:text-[#99CC00] transition-colors">Operating Framework</Link></li>
              <li><Link data-testid="footer-link-careers" to="/careers" className="text-white/65 hover:text-[#99CC00] transition-colors">Careers</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="text-white/65 hover:text-[#99CC00] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-black text-base mb-5">Reach Operations</h4>
            <ul className="space-y-3.5 text-sm text-white/65">
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[#99CC00] mt-0.5 flex-shrink-0" /> The Platina Tower, 6th Floor, MG Road, Gurgaon, Haryana — 122002</li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 text-[#99CC00] mt-0.5 flex-shrink-0" /> <a href="mailto:sarthak@onehill.in" className="hover:text-[#99CC00] transition-colors">sarthak@onehill.in</a></li>
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 text-[#99CC00] mt-0.5 flex-shrink-0" /> <a href="tel:+919953800053" className="hover:text-[#99CC00] transition-colors">+91 99538 00053</a></li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-cta-partner"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#99CC00] text-[#1F1F1F] px-6 py-3 text-sm font-black hover:bg-[#B5E000] transition-colors"
            >
              Partner With OneHill <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/45">
          <p>© {new Date().getFullYear()} OneHill Commerce Pvt. Ltd. — All rights reserved.</p>
          <p className="font-mono">onehill.in · Quick Commerce Expansion & Operations Partner</p>
        </div>
      </div>
    </footer>
  );
}
